import * as types from "../actions/actionTypes";
import { saveToLocalStorage } from "../utils/localStorageManager";

const initialState = {
  configLoaded: false,
  config: {},
  i18nLoaded: false,
  i18n: {},
  env: "",
  userList: [],
  goToLoginPage: false,
  newTaskNotification: false
};

const appReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.APP_REQUEST_CONFIG:
      return { ...state, configLoaded: false };
    case types.APP_REQUEST_CONFIG_END:
      return { ...state, configLoaded: true, config: action.config };
    case types.APP_REQUEST_I18N:
      return { ...state, i18nLoaded: false };
    case types.APP_REQUEST_I18N_END:
      return { ...state, i18nLoaded: true, i18n: action.i18n };
    case types.APP_REQUEST_USERLIST_END:
      return { ...state, userList: action.userList };
    case types.APP_FLUSH_DATAS: {
      saveToLocalStorage("userInformations", "");
      saveToLocalStorage("userList", "");
      return { ...state, userList: [], env: "", goToLoginPage: true };
    }
    case types.APP_ON_LOGIN_PAGE:
      return { ...state, goToLoginPage: false };
    case types.UPLOAD_END_REQUEST:
      return { ...state, newTaskNotification: true};
    case types.REQUEST_TASKS_SUCCESS:
      return { ...state, newTaskNotification: false };
    default:
      return state;
  }
};

export default appReducer;



// WEBPACK FOOTER //
// ./src/reducers/appReducer.js